import React, { useEffect, useState } from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { bool, string } from 'prop-types';
import { useContentfulContext } from '../../../providers/ContentfulContext';
import { clickEvent, loadEvent } from '../../utils/publisher';
import { getDefaultApplyNowURL, getPaymentEstimatorDetails } from '../../utils/plcc-promo-info';
import { PLCN_CARD_IMAGE_SMALL } from '../../utils/constants';
import { TermsAndConditionsDrawerContentful as TermsAndConditionsDrawer }
from '../../common/terms-and-conditions-drawer-contentful.component';
import './offers-for-you.style.scss';
import { formatNumber } from '../../utils/general';

export const OffersForYou = ({
  isMobile, price, isAppliance, paymentEstimatorCampaignCode, defaultCampaignCode
}) => {
  const [paymentEstimatorDetails, setPaymentEstimatorDetails] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);

  const openDrawer = () => {
    setShowDrawer(true);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
  };

  const displayIntroOffer = price < 300;
  const campaignCode = displayIntroOffer ? defaultCampaignCode : paymentEstimatorCampaignCode;

  const { plccData } = useContentfulContext();

  useEffect(() => {
    if (plccData) {
      loadEvent('plcc-est-bundle');
      if (displayIntroOffer) {
        setPaymentEstimatorDetails({ applyNowUrl: getDefaultApplyNowURL(plccData, campaignCode, isMobile) });
      } else {
        setPaymentEstimatorDetails(getPaymentEstimatorDetails(plccData, campaignCode, isMobile, isAppliance, price));
      }
    }
  }, [price, plccData]);

  const {
    monthlyPayment, financingMonths
  } = paymentEstimatorDetails || {};

  const paymentEstimatorText = () => {
    return (
      <div className="sui-leading-normal">
        <span className="sui-font-bold">Pay ${formatNumber(monthlyPayment)} per mo.** </span>suggested
        payments w/ <span className="sui-font-bold">{financingMonths}-mo. </span>financing**
        on this <span className="sui-font-bold">${formatNumber(price)} </span>purchase
      </div>
    );
  };

  const introOfferText = () => {
    return (
      <div className="sui-leading-normal">
        <span className="sui-font-bold">GET UP TO $100 OFF* </span>on
        <br />
        your qualifying purchase.
      </div>
    );
  };

  return (
    <>
      {showDrawer && (
        <TermsAndConditionsDrawer
          closeDrawer={closeDrawer}
          open={showDrawer}
          showFinancing
          applyNowClick={() => clickEvent('plcc-est-bundle')}
          price={price}
          isAppliance={isAppliance}
          campaignCode={campaignCode}
        />
      )}
      <div className="offers-wrapper">
        <span className="offer-label sui-font-bold">Offers for you</span>
        <div className="offers-content">
          <div>
            <Image
              src={PLCN_CARD_IMAGE_SMALL}
              alt="Apply Now"
              title="Apply Now"
              height={50}
              width={50}
              className="offers-card-image"
            />
          </div>
          <div className="offers-flex">
            {displayIntroOffer && introOfferText()}
            {!displayIntroOffer && paymentEstimatorText()}
            <button
              className="u__default-link u--paddingRight offers-no-wrap"
              onClick={openDrawer}
              type="button"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

OffersForYou.displayName = 'OffersForYou';

OffersForYou.propTypes = {
  paymentEstimatorCampaignCode: string.isRequired,
  defaultCampaignCode: string.isRequired,
  isMobile: bool,
  price: string.isRequired,
  isAppliance: bool,
};

OffersForYou.defaultProps = {
  isMobile: false,
  isAppliance: false,
};
